<!--
 功能名称:千里眼平台(技师)-我的(提醒设置)
 开发人:梁高权
 创建时间:2021/03/15
 最后修改时间:2021/03/15
 -->
<template>
<div class="remindSet-wrap">
  <NavBar/>
  <div class="content">
    <!-- `会员卡余额低于${notify_money}元提醒我` -->
    <van-cell :title="`会员卡余额低于${parseInt(notify_money)<100?'100':notify_money}元提醒我`">
      <!-- 使用 right-icon 插槽来自定义右侧图标 -->
      <template #right-icon>
        <van-button v-show="checked1" plain type="primary" round color="#666" @click="show1 = true,digit1=notify_money">编辑</van-button>
        <van-switch v-model="checked1" @change="change1" active-color="#0EC99F" inactive-color="#CDCDCD" size="21px" />
      </template>
    </van-cell>
    <van-cell :title="`会员间隔${parseInt(notify_space_day)<10?'10':notify_space_day}天没来提醒我`">
      <template #right-icon>
        <van-button v-show="checked2" plain type="primary" round color="#666" @click="show2 = true,digit2=notify_space_day">编辑</van-button>
        <van-switch v-model="checked2" @change="change2" active-color="#0EC99F" inactive-color="#CDCDCD" size="21px" />
      </template>
    </van-cell>

<!--    <van-cell title="会员生日提醒我">
      <template #right-icon>
        <van-switch v-model="param.checked3" active-color="#0EC99F" inactive-color="#CDCDCD" size="21px" />
      </template>
    </van-cell> -->

  </div>
  <van-popup v-model="show1">
    <div style="position: relative;height: 20px;"><van-icon color="#C8C8C8" style="position: absolute;right: -12px;top:10px" name="cross" size="16" @click="show1=false" /></div>
    <h5>会员卡余额低于</h5>
    <div class="Gfield">
      <van-field v-model="digit1"  type="digit" placeholder="请输入余额" maxlength="10"/>
      <span>元提醒</span>
    </div>
    <div class="Gbutton">
      <van-button plain type="primary" color="#666" @click="show1=false">取消</van-button>
      <van-button type="info" color="#2C6BF8" @click="ascertain1('digit1','show1','notify_money')">确定</van-button>
    </div>
  </van-popup>

  <van-popup v-model="show2">
    <div style="position: relative;height: 20px;"><van-icon color="#C8C8C8" style="position: absolute;right: -12px;top:10px" name="cross" size="16" @click="show2=false" /></div>
    <h5>会员间隔</h5>
    <div class="Gfield">
      <van-field v-model="digit2"  type="digit" placeholder="请输入天数" maxlength="10"/>
      <span>提醒</span>
    </div>
    <div class="Gbutton">
      <van-button plain type="primary" color="#666" @click="show2=false">取消</van-button>
      <van-button type="info" color="#2C6BF8" @click="ascertain2('digit2','show2','notify_space_day')">确定</van-button>
    </div>
  </van-popup>
</div>
</template>

<script>
import { mapState } from 'vuex'
import table from '@/api/table'
import { Toast } from 'vant'
export default{
  name:'remindSet',
  components: {'NavBar':() => import('@/components/NavBar')},
  data(){
    return{
      show1: false,
      show2: false,
      digit1: '',
      digit2: '',
      notify_money:'100',
      notify_space_day:'10',
      checked1: false,
      checked2: false,
      // checked3: true,
    }
  },
  computed:{
    ...mapState(['userStatus'])
  },
  mounted() {
    if(this.userStatus.notify_money<100){this.checked1=false}else{this.checked1=true}
    if(this.userStatus.notify_space_day<10){this.checked2=false}else{this.checked2=true}
    this.notify_money=this.userStatus.notify_money.toString()
    this.notify_space_day=this.userStatus.notify_space_day.toString()
  },
  methods:{
    change1(value){
      if(value) this.notify_money='100'
       else this.notify_money='0'
       this.changePushOption({notify_money:parseInt(this.notify_money),notify_space_day:parseInt(this.notify_space_day)})
    },
    change2(value){
      if(value) this.notify_space_day='10'
       else this.notify_space_day='0'
       this.changePushOption({notify_money:parseInt(this.notify_money),notify_space_day:parseInt(this.notify_space_day)})
    },
    ascertain1(v1,v2,v3){
      if(parseInt(this[v1])<100||parseInt(this[v1])>1000000||!this[v1]){
        Toast.fail('卡余额不能低于100元');
      }else{
        this[v3]=this[v1]
        this[v2]=false
        this.changePushOption({notify_money:parseInt(this.notify_money),notify_space_day:parseInt(this.notify_space_day)})
      }
    },
    ascertain2(v1,v2,v3){
      if(parseInt(this[v1])<10||parseInt(this[v1])>1000||!this[v1]){
        Toast.fail('间隔时长不能低于10天');
      }else{
        this[v3]=this[v1]
        this[v2]=false
        this.changePushOption({notify_money:parseInt(this.notify_money),notify_space_day:parseInt(this.notify_space_day)})
      }
    },
    changePushOption(param){
      table.changePushOption(param).then(response=>{
        console.log(response)
        if(response.data.result){
          this.$store.commit('updateNotify_money',parseInt(this.notify_money))
          this.$store.commit('updateNotify_space_day',parseInt(this.notify_space_day))
        }else{
          Toast.fail('修改失败')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.remindSet-wrap{
  .content{
    background: #fff;
    margin: 30px;
    padding: 10px 0px;
    border-radius: 16px;
    /deep/ .van-cell{
        padding: 0 30px;
        line-height: 110px;
        display: flex;
        align-items: center;
        .van-cell__title{
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
        }
        .van-button{
          padding: 0 15px;
          border-style:solid;
          border-width: 1px;
          height: 40px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          margin-right: 13px;
        }
    }
  }
  /deep/.van-popup--center{
    border-radius: 10px;
    padding:0 50px 40px;
    h5{
      line-height:32px;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .Gfield{
      margin-top: 26px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      background: #ECECEE;
      padding: 20px 24px;
      width: 446px;
      height: 72px;
      border-radius: 8px;
      .van-field{
        // height: 44px;
        input{background: #ECECEE;border-radius: 0}
      }
      .van-cell::after {
        border-bottom:none;
      }
      span{
         white-space:nowrap;
      }
    }
    .Gbutton{
      display: flex;
      justify-content: space-between;
      .van-button{
        border-style:solid;
        border-width: 1px;
        width: 200px;
        height: 70px;
      }
      .van-button--primary{
        border-color:#DCDCDC !important;
      }
    }
  }
}


</style>
